/**
 * Common stuff for effects
 *
 * @author Mamontov Andrey, 09/2018
 *
 */

export const toPayload = <T>(action: { payload: T }) => action.payload;
